import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getProfilesParams } from '~/routes';
import { updateHelpCenterSuggestions } from '../../zendesk-widget';

const RouteMonitor = ({ pathname, zendeskWidget }) => {
  useEffect(() => {
    // Let Zendesk Widget know when we've changed pages
    if (zendeskWidget && zendeskWidget.loaded && window && window.zE) {
      updateHelpCenterSuggestions(pathname);
    }
  }, [pathname]);
  return null;
};

RouteMonitor.propTypes = {
  pathname: PropTypes.string,
};

RouteMonitor.defaultProps = {
  pathname: '',
};

export default RouteMonitor;
